<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    class="button"
    :disabled="disabled"
    :class="classList"
    :type="type"
  >
    <span class="button__icon" v-if="icon"></span>
    <span class="button__text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
  export default {
    props: {
      type: { type: String, default: 'button' },
      disabled:  { type: Boolean, default: false },
      icon: { type: String },
      block: { type: Boolean, default: false },
      view: {
        default: 'secondary',
//        validator: prop => (['primary, secondary'].indexOf(prop) > -1)
      },
      size: {
        validator: prop => (['md'].indexOf(prop) > -1),
        default: 'md'
      }
    },
    computed: {
      classList () {
        return {
          [`button--${this.size}`]: true,
          [`button--${this.view}`]: true,
          'button--block': this.block,
          'button--disabled': this.disabled,
        }
      }
    }
  }
</script>

<style lang="scss">
  .button {
    @include button-reset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: currentColor;
    transition: 0.2s box-shadow;
    outline: none;

    @include more(scale) {
      padding-left: 24px;
      padding-right: 24px;
      height: 54px;
    }
    @include mq(scale) {
      padding-left: 6rem;
      padding-right: 6rem;
      height: 13.5rem;
    }
    @include less(tablet) {
      height: 42px;
      padding-left: 20px;
      padding-right: 20px;
    }

    &:hover, &:focus {
      box-shadow: 0 0 7px currentColor;
    }
  }

  .button--disabled {
    opacity: 0.7;
    pointer-events: none;
  }

  .button__text {
    color: #fff;
    font-weight: 600;
    @include mq(desktop) {
      font-size: 20px;
    }
    @include mq(scale) {
      font-size: 5rem;
    }
    @include mq(mobile) {
      font-size: 16px;
    }
  }

  .button--primary {
    color: $color-red;
  }
  .button--secondary {
    color: $color-cyan
  }

  .button--block {
    display: flex;
    width: 100%;
  }
</style>
